import { Table } from '../types';

export const prepareTablePayment = (table: Table, enabled: boolean): Table => ({
  ...table,
  status: 'PAYING',
  serviceFee: table.serviceFeeChosen || table.status === 'PAYING' || table.payments.length > 0
    ? table.serviceFee
    : enabled,
  serviceFeeChosen: true,
});

export const getNewOrderServiceFee = (table: Table, enabled: boolean): boolean =>
  table.items.length === 0 && table.payments.length === 0 ? enabled : table.serviceFee;
